import { render } from "./Uploader.vue?vue&type=template&id=1ae3091e&scoped=true"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"

import "./Uploader.vue?vue&type=style&index=0&id=1ae3091e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ae3091e"

export default script